import { TourInclusion } from "@/types/dto/pdp/pdp-dates-inclusions-pricing";

export const mockTourInclusions: TourInclusion[] = [
  {
    id: "on-tour-air",
    title: "On-tour air included on this tour",
    tooltipText: "On-tour air tooltip",
    hasModal: true,
    iconUrl: "/icons/plane.svg"
  },
  {
    id: "money-back",
    title: "Money-back travel protection plan",
    iconUrl: "/icons/insurance.svg"
  },
  {
    id: "chauffeur-service",
    title: "Roundtrip home-to-airport Private Chauffeur Service",
    iconUrl: "/icons/car.svg"
  },
  {
    id: "local-led",
    title: "Tours designed and led by locals",
    iconUrl: "/icons/local-guide.svg"
  },
  {
    id: "guaranteed-departures",
    title: "Many guaranteed departures available",
    iconUrl: "/icons/calendar.svg"
  }
];

// export const mockOfferDetails: OfferDetails = {
//   offerCode: "SAVEOCT",
//   offerTitle: "Save up to $350 pp",
//   offerAmount: "$350",
//   offerDescription: "Use source code \"SAVEOCT\" for savings. Offer valid on new bookings only made between 10/1/2025 – 10/15/2025. Offer valid on new bookings only and can expire earlier due to space or inventory availability. Savings amount will vary by tour and departure date, and is only available on select departures. Space is on a first come, first served basis.",
//   termsAndConditions: `Use source code "SAVEOCT" for savings. Offer valid on new bookings only made between 10/1/2025 – 10/15/2025.
//
// Offer valid on new bookings only and can expire earlier due to space or inventory availability. Savings amount will vary by tour and departure date, and is only available on select departures. Space is on a first come, first served basis.
//
// Offers are not valid on group, existing bookings or combinable with any other offer. Other restrictions may apply. Promotional pricing may remain in effect after the expiration date.`
// };
//
// export const mockTourDates: TourDate[] = [
//   {
//     packageDateId: "101",
//     startDate: "2025-05-02",
//     endDate: "2025-05-16",
//     strikeOutPrice: "$7,999",
//     singlePrice: "$9,999",
//     doublePrice: "$7,749",
//     specialDates: [{ title: "Special Event", description: "Experience the most festive time of the year — the celebratory week of St. Patrick's Day on this special departure." }],
//     offerPrice: "$7,749",
//     offerCode: "SAVEOCT",
//     statusMessage: undefined,
//     statusId: 1,
//     onTourAir: true,
//     bookNowUrl: "https://booking.example.com/101"
//   },
//   {
//     packageDateId: "102",
//     startDate: "2025-05-09",
//     endDate: "2025-05-23",
//     singlePrice: "$9,749",
//     doublePrice: "$7,749",
//     specialDates: [{ title: "Special Event", description: "Experience the most festive time of the year — the celebratory week of St. Patrick's Day on this special departure." }],
//     statusMessage: "Guaranteed",
//     statusId: 1,
//     onTourAir: false,
//     bookNowUrl: "https://booking.example.com/102",
//     offerCode: ""
//   },
//   {
//     packageDateId: "103",
//     startDate: "2025-06-15",
//     endDate: "2025-06-29",
//     singlePrice: "$9,749",
//     doublePrice: "$7,749",
//     specialDates: [],
//     statusMessage: "Only 3 Seats Remaining",
//     statusId: 1,
//     onTourAir: false,
//     bookNowUrl: "https://booking.example.com/103",
//     offerCode: ""
//   },
//   {
//     packageDateId: "104",
//     startDate: "2025-07-10",
//     endDate: "2025-07-24",
//     strikeOutPrice: "$7,999",
//     singlePrice: "$9,999",
//     doublePrice: "$7,749",
//     specialDates: [],
//     offerPrice: "$7,749",
//     offerCode: "SAVEOCT",
//     statusMessage: "Call to Book",
//     statusId: 1,
//     onTourAir: false,
//     bookNowUrl: "https://booking.example.com/104"
//   },
//   {
//     packageDateId: "105",
//     startDate: "2025-08-05",
//     endDate: "2025-08-19",
//     singlePrice: "$9,749",
//     doublePrice: "$7,749",
//     specialDates: [],
//     statusMessage: "Sold Out",
//     statusId: 3,
//     onTourAir: false,
//     bookNowUrl: "https://booking.example.com/105",
//     offerCode: ""
//   },
//   // 2026 dates
//   {
//     packageDateId: "201",
//     startDate: "2026-05-02",
//     endDate: "2026-05-16",
//     strikeOutPrice: "$8,299",
//     singlePrice: "$10,299",
//     doublePrice: "$7,949",
//     specialDates: [],
//     offerPrice: "$7,949",
//     offerCode: "SAVEOCT",
//     statusMessage: undefined,
//     statusId: 1,
//     onTourAir: true,
//     bookNowUrl: "https://booking.example.com/201"
//   },
//   {
//     packageDateId: "202",
//     startDate: "2026-06-10",
//     endDate: "2026-06-24",
//     singlePrice: "$9,949",
//     doublePrice: "$7,949",
//     specialDates: [],
//     statusMessage: "Guaranteed",
//     statusId: 1,
//     onTourAir: false,
//     bookNowUrl: "https://booking.example.com/202",
//     offerCode: ""
//   },
//   // 2027 dates
//   {
//     packageDateId: "301",
//     startDate: "2027-05-05",
//     endDate: "2027-05-19",
//     singlePrice: "$10,149",
//     doublePrice: "$8,149",
//     specialDates: [],
//     statusMessage: undefined,
//     statusId: 1,
//     onTourAir: false,
//     bookNowUrl: "https://booking.example.com/301",
//     offerCode: ""
//   }
// ];
//
// export const mockSpecialEventData = {
//   title: "Special Event",
//   description: "Experience the most festive time of the year — the celebratory week of St. Patrick's Day on this special departure."
// };
